import _ from 'lodash';
import {PRE_BIDS_TABLE_NAME, SOURCE_PRE_BIDS_TABLE} from "../../constants";
import PreBidSearch from "../models/PreBidSearch.model";
import PreBidsService from "../PreBidsService";
import SalesService from "../../sales/SalesService";
import {store} from "@/plugins/vuex";
import i18n from "@/shared/i18n";

let getDefaultTableData = () => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: '-created_at',
    search: '',
    searchModel: new PreBidSearch(),
    extraFilters: {},
    expand: 'bidder.customer,history,bidder.lots,bidder.auction.currency,clerk,lot.inventory,bidder.language',
    toggleColumns: {
      fields: getDefaultTableFields(),
      requiredFields: ['paddle_number', 'lot_no', 'amount'],
      defaultFields: [
        'lot_no',
        'paddle_number',
        'bidder',
        'amount',
        'type',
        'status',
        'date',
      ],
    }
  }
};

let getDefaultTableFields = () => {
  return [
    {key: "lot_no", label: i18n.t('Lot'), sortable: true, tdClass: "lot-no-col", isVisible: true},
    {
      key: "paddle_number",
      label: i18n.t('Paddle Number'),
      sortable: true,
      tdClass: "paddle-number-col",
      isVisible: true
    },
    {key: "bidder", label: i18n.t('Bidder'), sortable: true, tdClass: "bidder-col", isVisible: true},
    {key: "amount", label: i18n.t('Amount'), sortable: true, tdClass: "amount-col", isVisible: true},
    {key: "type", label: i18n.t('Type'), sortable: true, tdClass: "type-col", isVisible: true},
    {key: "status", label: i18n.t('Status'), sortable: true, tdClass: "status-col", isVisible: true},
    {key: "date", label: i18n.t('Date'), sortable: true, tdClass: "created-at-col", isVisible: true},
    {key: "created_at", label: i18n.t('Creation Date'), sortable: true, tdClass: "created-at-col", isVisible: false},
    {key: "updated_at", label: i18n.t('Update Date'), sortable: true, tdClass: "updated-at-col", isVisible: false},
    {key: "is_winner", label: i18n.t('Winner'), sortable: false, tdClass: "is-winner-col", isVisible: false},
    {key: "clerk", label: i18n.t('Clerk'), sortable: true, tdClass: "clerk-col", isVisible: false},
    {
      key: "actions",
      label: i18n.t('Actions'),
      sortable: false,
      class: "width-5",
      tdClass: "actions-col",
      isVisible: false,
      exclude_from_export: true
    },
    {
      key: "extra_step",
      label: i18n.t('Extra Step'),
      sortable: false,
      class: "width-5",
      tdClass: "extra_step-col",
      isVisible: false
    },
    {key: "phone", label: i18n.t('Phone 1'), sortable: false, class: "width-5", tdClass: "phone-col", isVisible: false},
    {
      key: "phone2",
      label: i18n.t('Phone 2'),
      sortable: false,
      class: "width-5",
      tdClass: "phone2-col",
      isVisible: false
    },
    {
      key: "description",
      label: i18n.t('Description'),
      sortable: false,
      class: "width-5",
      tdClass: "description-col",
      isVisible: false
    },
    {
      key: "lot_title",
      label: i18n.t('Lot Title'),
      sortable: false,
      class: "",
      tdClass: "lot_title-col",
      isVisible: false
    },
    {
      key: "lot_description",
      label: i18n.t('Lot Description'),
      sortable: false,
      class: "",
      tdClass: "lot_description-col",
      isVisible: false
    },
  ]
}

export default {
  namespaced: true,
  state: {
    modal: {
      show: false,
      object: null,
      source: null
    },
    manageClerksModal: {
      show: false,
      object: null,
      source: null
    },
    assignClerksModal: {
      loading: false,
      show: false,
      object: null,
      source: null,
      preBids: [],
    },
    preBidEditModal: {
      show: false,
      object: null,
      source: null,
      sale: null,
    },
    generatePdfModal: {
      show: false,
      object: null,
      source: null
    },
    tableSource: null,
    tableData: {
      sale: getDefaultTableData()
    },
    batchTelephoneBidGenerationModal: {
      loading: false,
      show: false,
      source: null,
      sale: null,
    },
  },
  actions: {
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    showModal({commit}, {object = null, source, sale} = {}) {
      commit('showModal', {object: _.cloneDeep(object), source, sale});
    },
    hideModal({commit}) {
      commit('hideModal');
    },
    showGeneratePdfModal({commit}, {object = null, source} = {}) {
      commit('showGeneratePdfModal', {object: _.cloneDeep(object), source});
    },
    hideGeneratePdfModal({commit}) {
      commit('hideGeneratePdfModal');
    },
    showManageClerksModal({commit}, {object = null, source} = {}) {
      commit('showManageClerksModal', {object: _.cloneDeep(object), source});
    },
    hideManageClerksModal({commit}) {
      commit('hideManageClerksModal');
    },
    showAssignClerksModal({commit}, {object = null, source} = {}) {
      commit('showAssignClerksModal', {object: _.cloneDeep(object), source});
    },
    hideAssignClerksModal({commit}) {
      commit('hideAssignClerksModal');
    },
    showPreBidEditModal({commit}, {object = null, source, sale = null} = {}) {
      commit('showPreBidEditModal', {object: _.cloneDeep(object), source, sale});
    },
    hidePreBidEditModal({commit}) {
      commit('hidePreBidEditModal');
    },
    createPreBid({commit}, sale) {
      return PreBidsService.createPreBid(sale);
    },
    async updatePreBid({commit, state}, bid) {
      let response = await PreBidsService.updatePreBid(bid.uuid, bid, 'bidder.customer,history,bidder.auction.currency,clerk');
      if (response.success) {
        if (state.preBidEditModal.source === SOURCE_PRE_BIDS_TABLE) {
          commit('updatePreBid', response.body);
        }
      }
      return response;
    },
    async updateSaleClerks({commit, dispatch}, payload) {
      let response = await SalesService.partialUpdateSale(payload.uuid, {clerks_uuids: payload.selectedClerks}, 'clerks.languages,currency')
      if (response.success) {
        commit('updateSaleClerks', response.body);
        dispatch('sales/updateCurrentSaleData', {clerks: response.body.clerks}, {root: true});
      }
      return response;
    },
    async getAssignClerksPreBidsData({commit}, params) {
      commit('updateAssignClerksModalLoading', true);
      let response = await PreBidsService.getPreBids({
        auction_uuid: params.auction_uuid,
        type: 'telephone',
        ordering: 'lot_no',
        limit: 1000
      })
      if (response.success) {
        commit('updateAssignClerksModalLoading', false);
        commit('updateAssignClerksModalData', response.body.results);
      }
    },
    async saveAssignedClerks({commit, dispatch}, data) {
      let response = await SalesService.partialUpdateSale(data.sale_uuid, {pre_bids_lot_spacing: data.pre_bids_lot_spacing}, 'clerks,currency');
      if (response.success) {
        commit('updateSale', response.body);
        let updateResponse = await PreBidsService.batchUpdatePreBids(data.requestData);
        if (updateResponse.success) {
          dispatch('getTableData');
        }
        return updateResponse;
      }
      return response;
    },
    async updateAssignClerksModalLoading({commit}, payload) {
      commit('updateAssignClerksModalLoading', payload);
    },
    async getTableParams({state}, payload = null) {
      let data;
      let currentTableData = state.tableData[state.tableSource];
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: currentTableData,
        tableName: PRE_BIDS_TABLE_NAME
      });

      if (payload) {
        data = {...payload.pagination, search: payload.search, ordering: payload.ordering,};
      } else {
        data = {...currentTableData.pagination, search: currentTableData.search, ordering: ordering}
      }

      if (currentTableData.searchModel) {
        const searchModelData = currentTableData.searchModel.toJSON();
        data = {...data, ...searchModelData}
      }

      if (currentTableData.extraFilters) {
        data = {...data, ...currentTableData.extraFilters};
      }

      const defaultExpand = currentTableData.expand
      const expand = currentTableData.toggleColumns.fields
        .filter(c => currentTableData.toggleColumns.defaultFields.includes(c.key) && c.expand && !defaultExpand.includes(c.expand))
        .map(c => c.expand)
        .join(',');

      data.expand = `${expand},${defaultExpand}`;

      return data;
    },
    async getTableData({commit, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);

      commit('updateTableLoading', true);
      const response = await SalesService.getPreBids(params);
      commit('updateTableLoading', false);

      if (response.success) {
        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering,
          search: params.search
        });
      }
      return response;
    },
    updateSearchModel({commit, state}, searchModel) {
      commit('updateSearchModel', new PreBidSearch({
        ...state.tableData[state.tableSource].searchModel,
        ...searchModel
      }));
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.tableData[state.tableSource].extraFilters;
      const tmpToggleColumns = _.cloneDeep(state.tableData[state.tableSource].toggleColumns);

      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      state.tableData[state.tableSource] = {
        ...state.tableData[state.tableSource],
        ...defaultTableData
      };
      state.tableData[state.tableSource].extraFilters = extraFilters;
      state.tableData[state.tableSource].toggleColumns = tmpToggleColumns;
      dispatch('getTableData');
    },
    async updateTableSource({state}, {extraFilters, source, sale}) {
      state.tableSource = source;
      state.tableData[source].extraFilters = extraFilters;
      state.tableData[source].sale = _.cloneDeep(sale);
    },
    async updateToggleColumns({commit, dispatch}, payload) {
      if (payload.isSaveAction) {
        commit('updateTableLoading', true);
        await commit('updateToggleColumns', payload.selectedColumns);
        await dispatch('getTableData');
        commit('updateTableLoading', false);
      } else {
        await commit('updateToggleColumns', payload.selectedColumns);
      }
    },
    async createPreBids({dispatch}, payload) {
      let response = await SalesService.createPreBids(payload);
      if (response.success) {
        dispatch('getTableData')
      }
      return response;
    },
    async batchRemovePreBids({dispatch}, payload) {
      let response = await SalesService.batchRemovePreBids(payload);
      if (response.success) {
        dispatch('getTableData')
      }
      return response;
    },
    async removeHistoryBid({state}, {bidUuid, historicBidUuid}) {
      let response = await PreBidsService.removeHistoryBid(historicBidUuid);
      if (response.success) {
        const index = state.tableData[state.tableSource].rows.findIndex(r => r.uuid === bidUuid);
        const innerIndex = state.tableData[state.tableSource].rows[index].history.findIndex(r => r.uuid === historicBidUuid);
        state.tableData[state.tableSource].rows[index].history.splice(innerIndex, 1);
      }
      return response;
    },
    async createWinnerBidFromPreBid({dispatch}, {uuid, data}) {
      let response = await PreBidsService.createWinnerBidFromPreBid(uuid, data)
      if (response.success) {
        dispatch('getTableData');
      }
      return response
    },
    showBatchTelephoneBidGenerationModal({state}, {source, sale}) {
      state.batchTelephoneBidGenerationModal.source = source
      state.batchTelephoneBidGenerationModal.sale = sale
      state.batchTelephoneBidGenerationModal.show = true
    },
    hideBatchTelephoneBidGenerationModal({state}) {
      state.batchTelephoneBidGenerationModal.show = false
      state.batchTelephoneBidGenerationModal.source = null
      state.batchTelephoneBidGenerationModal.sale = null
    },
    toggleBatchTelephoneBidGenerationModalLoading({state}, value) {
      state.batchTelephoneBidGenerationModal.loading = value
    },
  },
  mutations: {
    showModal: (state, {object, source, sale}) => {
      state.modal.show = true;
      state.modal.object = object;
      state.modal.source = source;
      state.modal.sale = sale;
    },
    hideModal: state => state.modal.show = false,
    showManageClerksModal: (state, {source, object}) => {
      state.manageClerksModal.show = true;
      state.manageClerksModal.source = source;
      state.manageClerksModal.object = object
    },
    hideManageClerksModal: state => state.manageClerksModal.show = false,
    showAssignClerksModal: (state, {source, object}) => {
      state.assignClerksModal.show = true;
      state.assignClerksModal.source = source;
      state.assignClerksModal.object = object
    },
    hideAssignClerksModal: state => state.assignClerksModal.show = false,
    showGeneratePdfModal: (state, {source, object}) => {
      state.generatePdfModal.show = true;
      state.generatePdfModal.source = source;
      state.generatePdfModal.object = object
    },
    hideGeneratePdfModal: state => state.generatePdfModal.show = false,
    showPreBidEditModal: (state, {object, source, sale}) => {
      state.preBidEditModal.show = true;
      state.preBidEditModal.object = object;
      state.preBidEditModal.source = source;
      state.preBidEditModal.sale = sale;
    },
    updatePreBid: (state, bid) => {
      const index = state.tableData[state.tableSource].rows.findIndex(r => r.uuid === bid.uuid);
      state.tableData[state.tableSource].rows[index] = {...state.tableData[state.tableSource].rows[index], ...bid};
      state.tableData[state.tableSource].rows = [...state.tableData[state.tableSource].rows];
    },
    hidePreBidEditModal: state => {
      state.preBidEditModal.show = false
      state.preBidEditModal.object = null
      state.preBidEditModal.source = null
      state.preBidEditModal.sale = null
    },
    updateTableLoading: (state, payload) => state.tableData[state.tableSource].loading = payload,
    updateTableData: (state, payload) => state.tableData[state.tableSource] = {...state.tableData[state.tableSource], ...payload},
    updateSearchModel: (state, searchModel) => state.tableData[state.tableSource].searchModel = searchModel,
    updateSaleClerks: (state, data) => {
      state.tableData[state.tableSource].sale = {...data}
    },
    updateAssignClerksModalLoading: (state, payload) => state.assignClerksModal.loading = payload,
    updateAssignClerksModalData: (state, payload) => {
      state.assignClerksModal.preBids = payload;
    },
    updateSale: (state, data) => state.tableData[state.tableSource].sale = {...data},
    updateToggleColumns: (state, selectedColumns) => {
      state.tableData[state.tableSource].toggleColumns.defaultFields = [...selectedColumns];
      let selectedFields = [];
      let notSelectedFields = [];
      selectedColumns.forEach(s => {
        selectedFields.push({
          ...state.tableData[state.tableSource].toggleColumns.fields.find(f => f.key === s),
          isVisible: true
        });
      });
      state.tableData[state.tableSource].toggleColumns.fields.forEach(f => {
        if (!selectedColumns.includes(f.key)) {
          notSelectedFields.push({...f, isVisible: false});
        }
      });
      state.tableData[state.tableSource].toggleColumns.fields = [...selectedFields, ...notSelectedFields];
    },
  }
}
